import { css, html, LitElement } from 'lit-element';
import 'lm-ui-kit/src/components/uc-button/uc-button.define';
import { pxToRem } from 'lm-ui-kit/src/utils/css-utils';
import { forgotPassword } from '../icons/success-forgot-password';
import { passwordRecovery } from '../icons/success-password-recovery';
import { errorSend } from '../icons/success-error-send';
import { desktop, tablet, mobile } from '../utils';

export const props = {
  type: { type: String },
  message: { type: String },
};

export class UcFormSuccess extends LitElement {
  static get properties() {
    return props;
  }

  static styles = css`
    :host {
      display: block;
      max-width: ${pxToRem(580)};
    }
    ${tablet(css`
      :host {
        margin-top: ${pxToRem(266)};
      }
    `)}
    ${desktop(css`
      :host {
        margin-top: ${pxToRem(166)};
      }
    `)}
    ${mobile(css`
      :host {
        margin-top: ${pxToRem(105)};
      }
    `)}
    
    .message {
      display: block;
      margin-bottom: ${pxToRem(32)};
      font-weight: 500;
      color: #333333;
      text-align: center;
    }
    ${tablet(css`
      .message {
        font-size: ${pxToRem(22)};
        line-height: ${pxToRem(28)};
      }
    `)}
    ${mobile(css`
      .message {
        font-size: ${pxToRem(18)};
        line-height: ${pxToRem(24)};
      }
    `)}
    
    .icon {
      display: block;
      margin-bottom: ${pxToRem(30)};
      text-align: center;
    }
    ${tablet(css`
      .icon svg {
        width: ${pxToRem(48)};
        height: ${pxToRem(48)};
      }
    `)}
    ${mobile(css`
      .icon svg {
        width: ${pxToRem(32)};
        height: ${pxToRem(32)};
      }
    `)}

    ::slotted(.actions-wrap) {
      display: flex;
      justify-content: center;
    }
  `;

  render() {
    return html`
      <div class="success">
        <span class="icon">${this.getIconByType(this.type)}</span>
        <span class="message">${this.message}</span>
        <slot name="btn"></slot>
      </div>
    `;
  }

  getIconByType(type) {
    let returnIco;
    switch (type) {
      case 'forgot':
        returnIco = forgotPassword;
        break;
      case 'recovery':
        returnIco = passwordRecovery;
        break;
      case 'error':
        returnIco = errorSend;
        break;
      default:
        returnIco = '';
        break;
    }
    return returnIco;
  }
}
